export const resources = {
    "Raag Kirtan": [
        { name: "History of Raag Kirtan", link: "https://gurmatsangeet.org/discover-gurmat-sangeet/" },
        { name: "Raag Kirtan Performance Guide", link: "https://www.searchgurbani.com/raags" }
    ],
    "Gurmat Sangeet": [
        { name: "Introduction to Gurmat Sangeet", link: "https://gurmatsangeet.org" }
    ],
    "Dilruba": [
        { name: "Dilruba Tuning Guide", link: "https://www.youtube.com/watch?v=QfmWSl6txRY" },
        { name: "Dilruba Playing Techniques", link: "https://www.youtube.com/shorts/JU8PhHg3Q9I" }
    ],
    "Hindustani Music Theory": [
        { name: "NIOS Hindustani Music Theory - Chapter 5", link: "https://www.nios.ac.in/media/documents/Hindustani_Music_242/hindustanimusictheorybook1/HMB1Ch5.pdf" }
    ],
    "Music Tools": [
        { name: "Online Metronome", link: "https://www.metronomeonline.com" },
        { name: "Tuner", link: "https://theonlinemetronome.com/instrument-tuner" },
        { name: "Online Tanpura", link: "https://www.spardhaschoolofmusic.com/tools/tanpura" },
        { name: "Online Tabla", link: "https://www.spardhaschoolofmusic.com/tools/tabla" }
    ],
    "General Resources": [
        { name: "Search Gurbani", link: "https://www.searchgurbani.com" },
        { name: "Spardha School of Music", link: "https://www.spardhaschoolofmusic.com" }
    ],
    "YouTube Channels": [
        { name: "History of Harmonium and Stringed Instruments in Sikh Kirtan", link: "https://www.youtube.com/watch?v=2IHJ1SRb6DY" },
        { name: "Top 5 steps for beginners, to play Dilruba - RajAcademy", link: "https://www.youtube.com/watch?v=ZcuM9K5mDaM" },
        { name: "Dilruba Lessons - Guru Ke Goleh", link: "https://www.youtube.com/watch?v=MJrKYaa7Fpo" },
        { name: "Simple Vaheguru Simran on Dilruba", link: "https://www.youtube.com/watch?v=z67iROl1p8E" },
        { name: "Dilruba played in Raag Malhar", link: "https://www.youtube.com/watch?v=hv0rjjIy0Xw"},
        { name: "Kirtan example", link: "https://www.youtube.com/watch?v=UD5S3W8UKFM"},
    ]
};
